import axios from 'axios';
import { call, put, take, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	getAvailablePlansRequest,
	getAvailablePlansSuccess,
	getCurrentPlanRequest,
	getCurrentPlanSuccess,
	pricingInitState,
	requestNewPlanRequest,
	requestNewPlanSuccess,
	getRequestedPlanRequest,
	getRequestedPlanSuccess,
} from './reducer';
import {
	TAvailablePlansResponsePayload,
	TCurrentPlanResponsePayload,
	TRequestNewPlanRequest,
	TRequestedPlanResponsePayload,
} from './types';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

function* getAvailablePlansWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TAvailablePlansResponsePayload = yield call(api.pricing.getAvailablePlans);
		yield put(getAvailablePlansSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getCurrentPlanWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TCurrentPlanResponsePayload = yield call(api.pricing.getCurrentPlan);
		yield put(getCurrentPlanSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* requestNewPlanWorker(action: PayloadAction<TRequestNewPlanRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.pricing.requestNewPlan, payload);
		yield put(requestNewPlanSuccess());
		yield put(getRequestedPlanRequest());
		notificationContainer('Request sent successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error))
			notificationContainer(
				error?.response?.data?.message ?? error.message ?? 'File download error',
				'error',
			);
		yield put(pricingInitState());
	}
}

function* getRequestedPlanWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TRequestedPlanResponsePayload = yield call(api.pricing.getRequestedPlan);
		yield put(getRequestedPlanSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

export function* pricingSaga() {
	yield takeEvery(getAvailablePlansRequest.type, getAvailablePlansWorker);
	yield takeEvery(getCurrentPlanRequest.type, getCurrentPlanWorker);
	yield takeEvery(requestNewPlanRequest.type, requestNewPlanWorker);
	yield takeEvery(getRequestedPlanRequest.type, getRequestedPlanWorker);
}
